import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Comment } from '../models/comment.model';
import { CrudService } from '../shared/grid/crud.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CommentService extends CrudService<Comment> {

    constructor(http: HttpClient) {
        super('Comment', http);
    }

    getComments(payload): Observable<Comment[]> {
        return this.http.post<Comment[]>(this.getApiUrl(`${this.controllerName}/GetComments`), payload);
    }
}
